import { render } from "./TestNumber.vue?vue&type=template&id=10a25140&scoped=true"
import script from "./TestNumber.vue?vue&type=script&lang=js"
export * from "./TestNumber.vue?vue&type=script&lang=js"

import "./TestNumber.vue?vue&type=style&index=0&id=10a25140&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a25140"]])

export default __exports__